import { useCallback, useState } from "react";

export function useCreateMilestoneDialog() {
  const [openCreateMilestoneDialog, setOpenCreateMilestoneDialog] =
    useState(false);

  const handleClickOpen = useCallback(() => {
    setOpenCreateMilestoneDialog(true);
  }, []);

  const handleClose = useCallback(() => {
    setOpenCreateMilestoneDialog(false);
  }, []);

  return {
    handleClickOpen,
    handleClose,
    openCreateMilestoneDialog,
  };
}
